import { __assign } from "tslib";
import React from 'react';
import { colors } from '../../theme';
import { FlexRow } from '../layout/FlexRow';
import { Typography } from './Typography';
import { Label } from './Label';
import imgGrantedLabel from '../../assets/images/granted-label.svg';
import { Button } from './Button';
import { IconButton } from './IconButton';
import { faCreditCard, faBadgeCheck, faClock, faTrash } from '@fortawesome/pro-solid-svg-icons';
export var BundleCard = function (props) {
    var _a, _b, _c;
    var _d = React.useState(false), hover = _d[0], setHover = _d[1];
    var handleMouseOver = function (state) {
        if (state === "over") {
            setHover(true);
        }
        else {
            setHover(false);
        }
    };
    return (React.createElement("div", __assign({ style: {
            borderRadius: '4px',
            paddingTop: '16px', paddingBottom: '16px',
            paddingLeft: '24px', paddingRight: '24px',
            backgroundColor: colors.white,
            width: props.width,
            border: "1px solid ".concat(props.isInProgress ? colors.yellow[50] : hover ? colors.gray[30] : colors.gray[20]),
            display: 'flex',
            flexDirection: 'column',
            rowGap: '16px',
            position: 'relative',
            minWidth: '304px'
        }, onMouseOver: function () { return handleMouseOver("over"); }, onMouseOut: function () { return handleMouseOver("out"); } }, props),
        React.createElement(FlexRow, { columnGap: '8px', alignItems: 'center', style: { position: 'relative' } },
            props.Icon ?
                React.createElement("div", { style: {
                        width: '34px', maxWidth: '34px',
                        height: '34px', maxHeight: '34px'
                    } }, props.Icon)
                :
                    null,
            props.isInProgress ? React.createElement(Label, { size: 'sm', variant: 'warning', text: 'Request in progress' }) : null,
            props.isGranted ?
                React.createElement("img", { src: imgGrantedLabel, width: '43px', height: '43px', alt: 'Granted', style: {
                        width: '43px',
                        height: '43px',
                        position: 'absolute',
                        right: '-25px',
                        top: '-17px',
                        borderRadius: '4px'
                    } })
                :
                    null),
        React.createElement(FlexRow, null,
            React.createElement(Typography, { variant: 'title-regular' }, props.title)),
        React.createElement(FlexRow, { justifyContent: 'space-between', columnGap: '8px', style: { marginTop: '8px' } },
            React.createElement(FlexRow, { columnGap: '8px' },
                props.showMoreInfoButton ?
                    React.createElement(Button, { variant: 'gray', onClick: props.onClickMoreInfoButton }, "More Info")
                    :
                        null,
                props.showSignInButton ?
                    React.createElement(Button, { variant: 'grayBlue', onClick: props.onClickSignInButton }, "Sign In")
                    :
                        null,
                props.showReviewButton ?
                    React.createElement(Button, { variant: 'gray', onClick: props.onClickReviewButton }, "Review")
                    :
                        null,
                props.showRequestButton ?
                    React.createElement(Button, { variant: 'grayBlue', onClick: props.onClickRequestButton }, "Request")
                    :
                        null,
                props.showCopyProfileButton ?
                    React.createElement(Button, { variant: 'grayBlue', onClick: props.onClickCopyProfileButton }, "Copy Profile")
                    :
                        null,
                props.showGrantedCountButton ?
                    React.createElement(Button, { icon: faCreditCard, iconColor: "#A6ABB6", iconPosition: "start", size: "sm", variant: "grayBlue", onClick: props.onClickGrantedCountButton }, ((_a = props.grantedCount) === null || _a === void 0 ? void 0 : _a.toString()) || '0')
                    :
                        null,
                props.showUngrantedCountButton ?
                    React.createElement(Button, { icon: faBadgeCheck, iconColor: "#A6ABB6", iconPosition: "start", size: "sm", variant: "grayBlue", onClick: props.onClickUngrantedCountButton }, ((_b = props.ungrantedCount) === null || _b === void 0 ? void 0 : _b.toString()) || '0')
                    :
                        null,
                props.showProgressCountButton ?
                    React.createElement(Button, { icon: faClock, iconColor: "#A6ABB6", iconPosition: "start", size: "sm", variant: "grayBlue", onClick: props.onClickProgressCountButton }, ((_c = props.progressCount) === null || _c === void 0 ? void 0 : _c.toString()) || '0')
                    :
                        null),
            React.createElement(FlexRow, { columnGap: '8px' }, props.showTrashButton ?
                React.createElement(IconButton, { icon: faTrash, variant: 'gray', size: 'sm', onClick: props.onClickTrashButton })
                :
                    null))));
};
BundleCard.defaultProps = {
    width: 'fit-content',
    showMoreInfoButton: true
};
